import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { ComparisonDirective } from './comparison.directive';
export class NotEqualToDirective extends ComparisonDirective {
public ngNotEqualTo: any;
constructor() {
    super('ngNotEqualTo');
  }
/**
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl): boolean {
    return control.value !== this.ngNotEqualTo;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngNotEqualTo]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NotEqualToDirective,
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngNotEqualTo': [{ type: Input },],
};
}

function NotEqualToDirective_tsickle_Closure_declarations() {
/** @type {?} */
NotEqualToDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotEqualToDirective.ctorParameters;
/** @type {?} */
NotEqualToDirective.propDecorators;
/** @type {?} */
NotEqualToDirective.prototype.ngNotEqualTo;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
